import React from 'react';
import youth from '../assets/youth.ico';
import ModernFooter from './modern/ModernFooter';

// Board-specific bits only; the design is shared (src/components/modern, 2026-10-02 refresh).
export default function Footer() {
  return <ModernFooter logo={<img src={youth} className="h-8 w-8" alt="" />} />;
}
